import {Button, Card, ConfigProvider, Form, Input} from "antd";
import {MailOutlined} from "@ant-design/icons";
import AuthLayout from "@/component/common/layout/AuthLayout.tsx";
import {useTranslation} from 'react-i18next';
import {AppValidator} from "@/common/app-validate.ts";
import {useState} from "react";
import {MANAGER_PATH} from "@/constant/url-path.ts";
import {AuthService} from "@/services/auth/AuthService.ts";
import CustomRequiredMarkAntdForm from "@/component/CustomRequiredMarkAntdForm.tsx";
import {useNavigate} from "react-router-dom";
import {toast} from "@/utils/toast.tsx";

const SignIn = () => {
    const {t} = useTranslation();
    const validators = AppValidator(t);
    const navigate = useNavigate();

    const [forgotPasswordForm] = Form.useForm();
    const [isSent, setIsSent] = useState<boolean>(false);

    const handleSendMail = async (values: any) => {
        const res = await AuthService.forgotPassword(values);
        if (res?.message) {
            setIsSent(true);
            toast.success(t("message.sentMailSuccessful"));
        }
    }

    return <>
        <AuthLayout>
            {isSent ?
                <Card
                    style={{
                        position: "absolute",
                        top: "20%",
                        left: "50%",
                        transform: "translate(-50%, 0%)",
                        width: 480,
                    }}
                    styles={{body: {padding: 40}}}
                >
                    <div
                        className={'text-[1.5rem] font-bold text-center mb-10'}>{t('title.forgotPasswordSentMail')}</div>
                    <ConfigProvider
                        theme={{
                            components: {
                                Button: {
                                    colorPrimary: '#4154F1'
                                },
                            },
                        }}
                    >
                        <Button
                            className={"mt-3 w-full"}
                            type="primary"
                            onClick={() => navigate(MANAGER_PATH.AUTH.SIGN_IN)}
                            size={'large'}
                        >
                            {t('button.backToLogin')}
                        </Button>
                    </ConfigProvider>
                </Card> :
                <Card
                    style={{
                        position: "absolute",
                        top: "20%",
                        left: "50%",
                        transform: "translate(-50%, 0%)",
                        width: 480,
                    }}
                    styles={{body: {padding: 40}}}
                >
                    <div className={'text-[1.5rem] font-bold text-center mb-10'}>{t('title.plsEnterYourEmail')}</div>
                    <Form
                        form={forgotPasswordForm}
                        name="forgot-password-form"
                        initialValues={{
                            remember: true,
                        }}
                        layout={"vertical"}
                        requiredMark={CustomRequiredMarkAntdForm}
                        onFinish={handleSendMail}
                        size={'large'}
                    >
                        <Form.Item
                            name="email"
                            label={t('field.email')}
                            rules={[
                                validators.required(t('field.email')),
                                validators.personalEmail()
                            ]}
                        >
                            <Input
                                prefix={<MailOutlined/>}
                                max={320}
                                placeholder={t('placeholder.enterYourEmail')}
                            />
                        </Form.Item>

                        <Form.Item>
                            <ConfigProvider
                                theme={{
                                    components: {
                                        Button: {
                                            colorPrimary: '#4154F1'
                                        },
                                    },
                                }}
                            >
                                <Button type="primary" htmlType="submit" className="w-full mt-4">
                                    {t('button.sendEmail')}
                                </Button>
                            </ConfigProvider>
                        </Form.Item>
                        <div className={''}>
                            <a className="" href={MANAGER_PATH.AUTH.SIGN_IN}>
                                {t('link.gotoLogin')}
                            </a>
                        </div>
                    </Form>
                </Card>
            }

        </AuthLayout>
    </>
}

export default SignIn;